<template>

  <v-dialog
    v-model="show"
    max-width="400px"
    persistent
  >
    <m-pay-generic-editor
      :title="title"
      :bean="model"
      :beanProperties="beanProperties"
      :beanPropertyValues="beanPropertyValues"
      :validationRules="validationRules"
      submitButtonColor="error"
      @submit="submit($event)"
      @cancel="cancel"
    >
      <template slot="submitButton">
        Refund
        <v-icon right dark>restore</v-icon>
      </template>
    </m-pay-generic-editor>
  </v-dialog>

</template>

<script>
import MPayGenericEditor from './MPayGenericEditor';
import formatters from '../utils/formatters';

export default {
  name: 'MPayConsumerCreditRefund',

  props: {
    show: Boolean,
    consumerCredit: Object,
  },

  components: {
    MPayGenericEditor,
  },

  data: () => ({
    model: {
      consumerCreditId: '',
      amount: 0,
      reason: '',
      internalNote: '',
      financingInstitutionTargetedNote: '',
    },
    beanProperties: [
      'amount',
      'reason',
      'internalNote',
      'financingInstitutionTargetedNote',
    ],
    formatters,
  }),

  computed: {
    validationRules() {
      return [
        `required|between:0.01,${this.consumerCredit.amount}`,
        'required',
        '',
        '',
      ];
    },
    beanPropertyValues() {
      return {
        reason: ['PRODUCT_OUT_OF_STOCK', 'RETURNED_PRODUCT', 'CANCELLED_SERVICE', 'PRICE_ADJUSTMENT', 'OTHER'],
      };
    },
    title() {
      return `Request consumer credit refund (order total amount ${formatters.amount(this.consumerCredit.amount)})`;
    },
  },

  methods: {
    submit(model) {
      this.$emit('update:show', false);
      this.$emit('refund', model);
    },
    cancel() {
      this.$emit('update:show', false);
    },
    resetModel() {
      this.model = {
        consumerCreditId: this.consumerCredit.id,
        amount: this.consumerCredit.amount,
        reason: '',
        internalNote: '',
        financingInstitutionTargetedNote: '',
      };
    },
  },

  watch: {
    consumerCredit() {
      this.resetModel();
    },
    show() {
      this.resetModel();
    },
  },

};
</script>



// WEBPACK FOOTER //
// src/components/MPayConsumerCreditRefund.vue